import Encrypt from '@shared/utils/encodingUtils';
import request from '@services/request';

const subsidiaryApi = '/api/v1/corresponsal/subsidiaries';
const importSubsidiaryApi = '/api/v1/corresponsal/importSubsidiaries';

const getActiveSubsidiaries = async () => {
  const result = await request.get(subsidiaryApi + '?active=true');
  const { data } = result;
  return data;
};

const getInactiveSubsidiaries = async () => {
  const result = await request.get(subsidiaryApi + '/list?active=false');
  const { data } = result;
  return data;
};

const getSubsidiaryByCity = async (city) => {
  const result = await request.get(subsidiaryApi + '/?city=' + city);
  const { data } = result;
  return data;
};

const createSubsidiary = async (subsidiary) => {
  const body = {
    ...subsidiary,
    correspondent_id: Encrypt.encode(subsidiary.correspondent_id),
  };
  const result = await request.post(subsidiaryApi, body);
  const { data } = result;
  return data;
};

const createSubsidiary2 = async (subsidiaries) => {
  const body = {
    data: subsidiaries.map((subsidiary) => {
      const newData = { ...subsidiary };
      delete newData.index;
      delete newData.sheetRow;
      newData.correspondent_id = Encrypt.encode(subsidiary.correspondent_id);
      return newData;
    }),
  };
  return request.post(importSubsidiaryApi, body);
};

const updateSubsidiary = async (subsidiaryId, subsidiary) => {
  const body = {
    ...subsidiary,
  };
  const result = await request.patch(`${subsidiaryApi}/${subsidiaryId}`, body);
  const { data } = result;
  return data;
};

const deleteSubsidiary = async (subsidiaryId) => {
  const result = await request.methodDelete(`${subsidiaryApi}/${subsidiaryId}`);
  const { data } = result;
  return data;
};

const getSubsidiaries = async (correspondentId, query) => {
  const url = `${subsidiaryApi}/supervisors?correspondentId=${Encrypt.encode(correspondentId)}`;
  const result = await request.get(url, query);
  const { data } = result;
  return data;
};

const getSubsidiarySupervisors = async (subsidiary) => {
  const result = await request.get(`${subsidiaryApi}/${Encrypt.encode(subsidiary.id)}/supervisors`);
  const { data } = result;
  return data;
};

const getAvailableSupervisors = async (params) => {
  const { data } = await request.get('/api/v1/corresponsal/subsidiaries/availableSupervisors', params);
  const { data_set: dataSet } = data.data;
  return dataSet;
};

const updateSubsidiarySupervisors = async (subsidiary, supervisors) => {
  const profiles = supervisors.map((sup) => ({ profile_id: sup.profile_id }));
  const { data } = await request.put(`/api/v1/corresponsal/subsidiaries/${subsidiary.id}/supervisors`, {
    supervisors: profiles,
  });
  const { data_set: dataSet } = data.data;
  return dataSet;
};

export {
  createSubsidiary,
  createSubsidiary2,
  deleteSubsidiary,
  getActiveSubsidiaries,
  getAvailableSupervisors,
  getInactiveSubsidiaries,
  getSubsidiaries,
  getSubsidiaryByCity,
  getSubsidiarySupervisors,
  updateSubsidiary,
  updateSubsidiarySupervisors,
};
